import React, { useEffect, useState } from "react";
import { X, Download } from "lucide-react";
import { useInstallPrompt } from "../hooks/useInstallPrompt";
import InstallAppButton from "./InstallAppButton";

const DAY_KEY = "linkia_install_banner_day";

/**
 * Banner estilo toast no rodapé oferecendo a instalação do app.
 * Aparece no máximo UMA vez por dia (mobile e desktop), com botão de fechar.
 */
export default function InstallAppBanner() {
    const { canInstall, isIOS } = useInstallPrompt();
    const [visible, setVisible] = useState(false);
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!canInstall && !isIOS) return;
        const today = new Date().toDateString();
        if (localStorage.getItem(DAY_KEY) === today) return;
        const t = setTimeout(() => {
            localStorage.setItem(DAY_KEY, today);
            setVisible(true);
            requestAnimationFrame(() => requestAnimationFrame(() => setShow(true)));
        }, 2500);
        return () => clearTimeout(t);
    }, [canInstall, isIOS]);

    if (!visible) return null;

    const close = () => {
        setShow(false);
        setTimeout(() => setVisible(false), 260);
    };

    return (
        <div
            className={`fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-[360px] z-[65] ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
            style={{ transitionProperty: "opacity, transform", transitionDuration: "260ms", transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)" }}
            data-testid="install-app-banner"
        >
            <div className="flex items-center gap-3 bg-[#141414] border border-border rounded-lg shadow-2xl px-4 py-3">
                <div className="w-9 h-9 rounded-md bg-primary/15 border border-primary/30 flex items-center justify-center shrink-0">
                    <Download className="w-4 h-4 text-primary" strokeWidth={2.2} />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold truncate">Instale o app Linkia</div>
                    <div className="text-[11px] text-muted-foreground truncate">Acesso rápido direto da sua tela inicial.</div>
                </div>
                <InstallAppButton
                    compact={false}
                    className="shrink-0 flex items-center gap-1.5 bg-primary hover:opacity-90 text-white rounded-full px-3 py-1.5 transition-opacity"
                />
                <button
                    type="button"
                    onClick={close}
                    data-testid="install-banner-close"
                    className="shrink-0 p-1.5 -mr-1 text-muted-foreground hover:text-foreground hover:bg-muted rounded-sm transition-colors"
                    aria-label="Fechar"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
